<div class="landing-header">
  <h1>Latest News</h1>

  <mat-form-field>
    <mat-select [(ngModel)]="selectedCategory" (ngModelChange)="filterArticlesByCategory()">
      <mat-option *ngFor="let category of categoryDropdownOptions" [value]="category">{{ category }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="content-container">
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div *ngFor="let article of featuredArticles" class="swiper-slide">
        <div [style.background-image]="'url(' + getFeaturedArticleBackgroundImage(article) + ')'" class="slide-content">
          <div class="inner">
            <span>{{ article.date | date: "MMMM d, yyyy" }}</span> 

            <p>{{ article.title }}</p>
            
            <button class="button" routerLink="/news/article/{{ article.id }}">
              <img alt="Go to Article" src="assets/images/arrow.svg">
            </button>
          </div>
          
          <img *ngIf="article.categories" class="icon" src="{{ getArticleCategoryIcon(article) }}" alt="{{ getArticleCategoryName(article) }} Icon">
        </div>
      </div>
    </div>

    <div class="swiper-pagination"></div>
  </div>
</div>

<div class="wrapper">
  <div *ngFor="let article of filteredArticles | slice:0:currentArticlesDisplayCount" routerLink="/news/article/{{ article.id }}"
    class="article">

    <img *ngIf="article.featuredImageUrl" src="{{ article.featuredImageUrl }}" alt="{{ article.featuredImageAlt }}" class="featured">

    <div class="inner">
      <div class="content">
        <h2>{{ article.title }}</h2>
      
        <p [innerHTML]="article.excerpt"></p>
      </div>

      <footer>
        <span>{{ article.date | date: "MMMM d, yyyy" }}</span>

        <img *ngIf="article.categories" src="{{ getArticleCategoryIcon(article) }}" alt="{{ getArticleCategoryName(article) }} Icon">
      </footer>
    </div>
  </div>
</div>

<button *ngIf="currentArticlesDisplayCount < filteredArticles.length" (click)="loadMoreArticles()">Load More</button>
